import { render, staticRenderFns } from "./modifyDomain.vue?vue&type=template&id=1aa5180a&scoped=true"
import script from "./modifyDomain.vue?vue&type=script&lang=js"
export * from "./modifyDomain.vue?vue&type=script&lang=js"
import style0 from "./modifyDomain.vue?vue&type=style&index=0&id=1aa5180a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa5180a",
  null
  
)

export default component.exports